import {contentService} from "../api/contentService";
import {useMutation} from "@apollo/client";
import {ReviewFeedbackMutationModel} from "../models/view/reviewFeedbackMutationModel";
import {useEffect, useMemo, useState} from "react";
import {Nullable} from "../definitions/types";
import {StatusTypes} from "../definitions/enums";

export const useReviewFeedbackMutation = () => {
    const [variables, setVariables] = useState<Nullable<{ reviewId: number, reason?: string }>>(null);
    const [model, setModel] = useState<Nullable<ReviewFeedbackMutationModel>>(null);
    const [createReviewFeedbackAsync, {
        error,
        loading,
        reset
    }] = useMutation(contentService.ratings.review.feedback.increment);

    useEffect(() => {
        if (!variables) return;
        createReviewFeedbackAsync({variables})
            .then(({data, errors}) => setModel(new ReviewFeedbackMutationModel(data?.payload?.reviewFeedback, errors)))
            .catch()
            .finally(() => setVariables(null));
    }, [variables]);

    const status = useMemo(() => {
        if (loading) return StatusTypes.Loading;
        if (error) return StatusTypes.Error;
        if (model?.hasErrors === true) return StatusTypes.Error;
        if (model?.success === true) return StatusTypes.Success;
        return StatusTypes.Default;
    }, [loading, error, model]);

    return {
        loading: status === StatusTypes.Loading,
        complete: status === StatusTypes.Success || status === StatusTypes.Error,
        create: (variables: { reviewId: number, reason?: string }) => setVariables(variables),
        reset: () => {
            reset();
            setModel(null);
            setVariables(null);
        }
    }
}